import { createFileRoute, Outlet } from '@tanstack/react-router'

/** The visit and its customer document (the visit report), under the visit's crumb. */
export const Route = createFileRoute('/_app/service/visits/$visitId')({
  staticData: { crumb: 'serviceVisit' },
  component: Outlet,
})
